import FormWrapper from '../../../layout/FormWrapper/FormWrapper';
import FormLayout from '../../../layout/FormLayout/FormLayout';
import Input from '../../../../../components/Input/Input';

const StorageViewStructure = ({ selectedData, onClose }: any) => {
    return (
        <FormWrapper isSmall={true} mode={'view'}>
            <FormLayout
                title={'Investment vehicle'}
                description={'The basic information about the investment vehicle.'}
                onClose={onClose}
            >
                <Input readOnly value={selectedData.name}>
                    Fund name
                </Input>
                <Input readOnly value={selectedData.launchDate}>
                    Launch date
                </Input>
                <Input disabled value={'No information'}>
                    Link to another structure
                </Input>
                <Input readOnly value={selectedData.domicileName}>
                    Domicile
                </Input>
                <Input readOnly value={selectedData.type}>
                    Structure type
                </Input>
                <Input readOnly value={selectedData.legalType}>
                    Fund type
                </Input>
                <Input readOnly value={selectedData.investmentFund}>
                    Fund Regime
                </Input>
                <Input readOnly value={selectedData.legalForm}>
                    Legal form
                </Input>
            </FormLayout>
        </FormWrapper>
    );
};

export default StorageViewStructure;
